<template>
  <div>
    <header>
      <!-- 搜索框 -->
      <div class="white-card" id="search">
        <div class="search input-wrap">
          <input
            type="text"
            placeholder="这里有你想要"
            v-model.trim="key"
            @keydown.enter.prevent="sumbit"
          />
          <span class="iconfont icon-sousuo1" @click.stop="sumbit"></span>
        </div>
      </div>
      <h3>搜索关键字:{{ title }}</h3>
    </header>
    <section class="card-wrap">
      <template v-if="list.length">
        <blog-card v-for="blog in list" :key="blog.blogId" :blog="blog">
        </blog-card>

        <div class="btn-wrap" v-if="list.length < allList.length">
          <button class="primary-btn plain" @click.stop="loadmore">
            加载更多
          </button>
        </div>
        <div v-else class="no-data">
          <span>~ 已加载全部 ~</span>
        </div>
      </template>
      <template v-else>
        <div class="no-data">
          <img src="@/assets/images/no-data.png" alt="" />
          <div>哦豁~没有找到您要的数据!</div>
        </div>
      </template>
    </section>
  </div>
</template>
<script>
import data from "./index.js";
export default data;
</script>
<style scoped>
#search {
  display: none;
}
@media (max-width: 950px) {
  #search {
    display: block;
  }
}
.no-data img {
  width: 300px;
  height: 300px;
}
</style>